
const adjectives = [
  'Clutch', 'Twilight', 'Lucky', 'Golden', 'Iron',
  'Steady', 'Bold', 'Swift', 'Sunday', 'Ace',
  'Fearless', 'Classic', 'Smooth', 'Grand', 'Epic',
  'Mighty', 'Royal', 'Sharp', 'Fierce', 'Prime',
];

const nouns = [
  'Eagles', 'Putters', 'Drivers', 'Birdies', 'Irons',
  'Wedges', 'Fairways', 'Greens', 'Links', 'Bogeys',
  'Aces', 'Hooks', 'Draws', 'Chips', 'Pars',
  'Caddies', 'Mashies', 'Dimples', 'Tees', 'Pins',
];

/** Generate a random golf-themed game name like "Clutch Eagles" */
export const generateGameName = (): string => {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${adj} ${noun}`;
};
